import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import { withTheme } from 'contexts/ThemeContext';

const DivWrapper = ({ themeColors, ...rest }) => {
  return <div {...rest} />;
};

DivWrapper.defaultProps = {
  themeColors: {}
};

DivWrapper.propTypes = {
  themeColors: PropTypes.objectOf(PropTypes.any)
};

export const DropdownStyleContainer = styled(DivWrapper)`
  background-color: transparent;
  font-size: 12px;
  color: ${({ themeColors }) => themeColors.designSystem?.ink};
  border: 1px solid ${({ themeColors }) => themeColors.designSystem?.line};
  border-radius: 6px;
  margin-right: 5px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  &:focus-within {
    border-color: ${({ themeColors }) => themeColors.designSystem?.teal};
    box-shadow: 0 0 0 2px
      ${({ themeColors }) => themeColors.designSystem?.tealGlow};
  }
  .MuiMenuItem-root {
    min-height: 30px;
    padding: 5px 9px;
    font-size: 12px;
    color: ${({ themeColors }) => themeColors.designSystem?.ink};
  }
  .MuiSvgIcon-root {
    color: ${({ themeColors }) => themeColors.designSystem?.faint};
    font-size: 18px;
  }
  .drop-elipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 200px;
    font-size: 12px;
    color: ${({ themeColors }) => themeColors.designSystem?.ink};
  }
`;

export default withTheme(DropdownStyleContainer);
